import React, { FC, lazy, Suspense } from 'react'
import clsx from 'clsx'

import Layout from '@/components/Layout'
import { Logo, Menu, Social } from '.'

const Animation = lazy(() => import('./Animation'))

interface Props {
	hideAnimation?: boolean
}

/**
 * @component Footer
 * @description Page footer. The Lottie animation is lazy-loaded to keep
 * @lottiefiles/dotlottie-react (and its WASM runtime) out of the eager bundle.
 */
const Footer: FC<Props> = ({ hideAnimation = false }) => {
	return (
		<footer className="w-full overflow-hidden flex flex-col items-center justify-center">
			{ !hideAnimation && (
				<>
					<Suspense fallback={ <div className="h-56.25 md:h-75 w-full" /> }>
						<Animation />
					</Suspense>
					<div className="-mt-15.5 md:-mt-20.75 w-full pt-32 md:pt-30.5 bg-green-500 -z-1" />
				</>
			) }
			<Layout
				classNameContainer={clsx(
					'relative z-10 pt-0 pb-16 w-full bg-green-500',
					hideAnimation ? 'mt-0' : '-mt-15.5',
					'md:pb-30'
				)}
				classNameInnerContainer="flex flex-col"
			>
				<Logo />
				<div className={clsx(
					'flex flex-col gap-10',
					'md:gap-16'
				)}>
					<Menu />
					<Social />
				</div>
			</Layout>
		</footer>
	)
}

export default Footer
